import { TmsGraphRepository } from '@/core/repositories/tms-graph.repository'
import {
    DownloadReportAutoGraphParams,
    DownloadReportAutoGraphResponse,
    GetPreTripDetailsResponse,
    GetPreTripsParams,
    GetPreTripsResponse,
    PreTripUpdateCommentPayload,
    UpdatePreTripPayload,
} from '@/core/types/tms-graph.types'

const tmsGraphRepository = new TmsGraphRepository()

export class TmsGraphService {
    async getPreTrips(params: GetPreTripsParams): Promise<GetPreTripsResponse> {
        const response = await tmsGraphRepository.getPreTrips(params)
        return response.data
    }

    async getPreTripDetails(id: number): Promise<GetPreTripDetailsResponse> {
        const response = await tmsGraphRepository.getPreTripDetails(id)
        return response.data
    }

    async updatePreTrip(id: number, payload: UpdatePreTripPayload): Promise<void> {
        const response = await tmsGraphRepository.updatePreTrip(id, payload)
        return response.data
    }

    async createScheduleExcel(payload: FormData): Promise<void> {
        const response = await tmsGraphRepository.createScheduleExcel(payload)
        return response.data
    }

    async downloadReportAutoGraph(
        params: DownloadReportAutoGraphParams
    ): Promise<DownloadReportAutoGraphResponse> {
        const response = await tmsGraphRepository.downloadReportAutoGraph(params)
        return response.data
    }

    async getPretripsForCompleteDay(): Promise<any> {
        const response = await tmsGraphRepository.getPretripsForCompleteDay()
        return response.data
    }

    async updateComment(id: number, payload: PreTripUpdateCommentPayload): Promise<void> {
        const response = await tmsGraphRepository.updateComment(id, payload)
        return response.data
    }
}
